import React from 'react';
import { Link } from 'react-router-dom';

export default function PompesChaleurPage() {
  return (
    <>
      {/* Hero */}
      <section className="page-hero" style={{ background: "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.45)), url('/assets/images/PompeaChaleur.jpeg') center/cover" }}>
        <div className="container" style={{ width: '100%' }}>
          <div className="hero-content">
            <h1 className="hero-title">Pompes à <span className="text-accent">Chaleur</span></h1>
            <p className="hero-subtitle">Chauffage et climatisation écologique avec un rendement exceptionnel. Réalisez jusqu'à <strong>70% d'économies</strong> sur vos factures de chauffage.</p>
            <div className="hero-buttons" style={{ justifyContent: 'center', maxWidth: '400px', margin: '0 auto' }}>
              <Link to="/#contact" className="btn btn-primary" style={{ padding: '14px 28px', fontSize: '1rem' }}>Demander un devis gratuit</Link>
              <a href="tel:0465845177" className="phone-number" style={{ color: 'white', borderColor: 'white' }}>04 65 84 51 77</a>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages */}
      <section className="advantages-section">
        <div className="container">
          <div className="section-header">
            <h2>Pourquoi choisir une <span className="text-accent">pompe à chaleur</span> ?</h2>
            <p>La solution de chauffage la plus efficace et écologique du marché</p>
          </div>
          <div className="advantages-grid">
            {[
              { title: "Jusqu'à 70% d'économies", text: "Réduisez drastiquement vos factures grâce à un coefficient de performance exceptionnel (COP jusqu'à 5)." },
              { title: 'Chauffage et climatisation', text: "Une seule installation pour chauffer en hiver et rafraîchir en été. Confort optimal toute l'année." },
              { title: 'Énergie renouvelable', text: "Utilise les calories gratuites de l'air extérieur. Solution écologique qui réduit votre empreinte carbone." },
              { title: 'Aides financières importantes', text: "Bénéficiez de Ma Prime Rénov', des CEE et d'autres aides pour réduire significativement votre investissement." },
            ].map((a) => (
              <div className="advantage-card" key={a.title}>
                <div className="advantage-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor"><path d="M17 8C8 10 5.9 16.17 3.82 20.49L5.71 21l1-2.3A4.49 4.49 0 0 0 8 19c9-3 6-8 12-11-1 4-4 7-6 8 1.5.5 3.5.5 5-1.5-1 5-5 6.5-8 6.5 1 1 1 2 1 2-4-1-8-5-8-9 0-5 3.5-9 7-11z"/></svg>
                </div>
                <h3>{a.title}</h3>
                <p>{a.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Products */}
      <section className="products-section">
        <div className="container">
          <div className="section-header">
            <h2>Nos <span className="text-accent">pompes à chaleur</span></h2>
            <p>Des solutions adaptées à tous types d'habitations et de besoins</p>
          </div>
          <div className="products-grid">
            {[
              {
                img: '/assets/images/AdobeStock_88357856.jpeg',
                title: 'PAC Air-Eau',
                desc: 'Idéale pour le chauffage central et la production d\'eau chaude sanitaire. Compatible avec vos radiateurs existants.',
                specs: [{ v: 'COP 4.5', l: 'Performance' }, { v: '70%', l: 'Économies' }, { v: '12 kW', l: 'Puissance' }, { v: '25 ans', l: 'Durée vie' }],
                advantages: ['Compatible plancher chauffant', 'Production eau chaude sanitaire', 'Classe énergétique A++', 'Éligible MaPrimeRénov\''],
              },
              {
                img: '/assets/images/AdobeStock_174899157.jpeg',
                title: 'PAC Air-Air',
                desc: 'Solution de climatisation réversible. Idéale pour chauffer et rafraîchir des pièces spécifiques.',
                specs: [{ v: 'COP 5', l: 'Performance' }, { v: '60%', l: 'Économies' }, { v: '9 kW', l: 'Puissance' }, { v: '20 ans', l: 'Durée vie' }],
                advantages: ['Installation rapide', 'Chauffage et climatisation', 'Fonctionnement silencieux', 'Design moderne'],
                featured: true,
              },
            ].map((p) => (
              <div className={`product-card ${p.featured ? 'featured' : ''}`} key={p.title}>
                {p.featured && <div className="product-badge">Recommandé</div>}
                <div className="product-image"><img src={p.img} alt={p.title} /></div>
                <div className="product-content">
                  <h3>{p.title}</h3>
                  <p className="product-description">{p.desc}</p>
                  <div className="product-specs-grid">
                    {p.specs.map((s) => (<div className="spec-item" key={s.l}><div className="spec-value">{s.v}</div><div className="spec-label">{s.l}</div></div>))}
                  </div>
                  <ul className="advantages-list" style={{ marginBottom: '20px' }}>
                    {p.advantages.map((adv) => (
                      <li key={adv}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                        <span>{adv}</span>
                      </li>
                    ))}
                  </ul>
                  <Link to="/#contact" className="btn btn-primary" style={{ display: 'block', textAlign: 'center' }}>Demander un devis</Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="installation-process">
        <div className="container">
          <div className="section-header">
            <h2>Notre processus <span className="text-accent">d'installation</span></h2>
          </div>
          <div className="process-steps">
            {[
              { n: 1, title: 'Audit énergétique', text: "Analyse de votre logement, calcul des déperditions thermiques et dimensionnement de la PAC." },
              { n: 2, title: 'Demandes d\'aides', text: "Constitution du dossier MaPrimeRénov', CEE, éco-PTZ et autres aides disponibles." },
              { n: 3, title: 'Installation', text: "Pose par nos techniciens certifiés RGE en 1 à 3 jours selon le type de PAC." },
              { n: 4, title: 'Mise en service', text: "Réglage, tests de performance et formation à l'utilisation de votre nouvelle installation." },
            ].map((s) => (
              <div className="process-step" key={s.n}>
                <div className="step-number">{s.n}</div>
                <h3>{s.title}</h3>
                <p>{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2>Changez votre système de chauffage !</h2>
          <p>Réduisez vos factures dès cet hiver avec une pompe à chaleur</p>
          <div className="cta-buttons">
            <Link to="/#contact" className="btn btn-white" style={{ padding: '14px 30px', fontSize: '1rem' }}>Demander mon devis gratuit</Link>
            <a href="tel:0465845177" className="btn-outline-white" style={{ padding: '14px 30px', fontSize: '1rem' }}>Appeler le 04 65 84 51 77</a>
          </div>
        </div>
      </section>
    </>
  );
}
